import { useEffect, useState } from 'react';
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from 'react-redux';
import Celikler from '../../components/general/Celikler';
import { fetchPageGetSlug } from '../../redux/slices/pageGetSlugSlice';
import { fetchSeoGet } from '../../redux/slices/seoGetSlice';
import ChargingSystem from './ChargingSystem';
import ElectricVehicleChargingSystems from './ElectricVehicleChargingSystems';
import Slider from './Slider';
import Sss from './Sss';

const HomePage = () => {
    const page = useSelector((state) => state.pageGetSlug.data);
    const lang = useSelector((state) => state.lang.lang);
    const seo = useSelector((state) => state.seoGet.data);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    const getData = async () => {
        setLoading(true)
        await dispatch(fetchPageGetSlug({ slug: "anasayfa" }));
        await dispatch(fetchSeoGet({ slug: "anasayfa" }));
        setLoading(false)
    }

    useEffect(() => { getData() }, [])

    return (
        !loading ? <Celikler>
            {seo && seo.title && seo.description && (
                <Helmet>
                    <title>{seo.title?.[lang] || "Çelikler Enerji"}</title>
                    <meta name="description" content={seo.description?.[lang] || ""} />
                    <meta name="keywords" content={seo.keywords?.[lang] || ""} />
                    <meta name="robots" content="index, follow" />
                    <link rel="canonical" href={window.location.href} />
                </Helmet>
            )}
            <Slider data={page?.showcases[0]} />
            <ChargingSystem data={page?.showcases[1]} />
            <ElectricVehicleChargingSystems data={page?.showcases[2]} />
            <Sss data={page?.showcases[3]} />
        </Celikler> : <div className="modern-spinner-wrapper">
            <div className="modern-spinner"></div>
        </div>
    )
}

export default HomePage
